/* eslint-disable */

/**
 * SSR ready polyfill for window.CustomEvent.
 */
export function CustomEvent() {
  if (typeof window === 'undefined' || typeof window.CustomEvent === 'function') {
    return;
  }
  function event(eventName) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    // Default values are used if params object is passed but is missing some properties.
    var _params$bubbles = params.bubbles,
      bubbles = _params$bubbles === void 0 ? false : _params$bubbles,
      _params$cancelable = params.cancelable,
      cancelable = _params$cancelable === void 0 ? false : _params$cancelable,
      detail = params.detail;
    if (!params) throw new Error('CustomEvent: params object is required.');
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(eventName, bubbles, cancelable, detail);
    return evt;
  }

  // Added for test environments not having window.Event
  // Also, not sure this is even needed since event() constructor returns a CustomEvent.
  if (window.Event && window.Event.prototype) {
    event.prototype = window.Event.prototype;
  }

  // @ts-expect-error
  window.CustomEvent = event;
}
export default CustomEvent;